var fvChannel = require('glRadio').channel('FV');
var moment = require('moment');
var _ = require('underscore');


_.extend(moment, {

    /*
     *
     * Convert dtString to local time and return it formatted in Doc Viewer's default date-time format string.
     * If dtString is null (typically provided directly from server), return an empty string to prevent error.
     * dtString is passed using a standard ISO format -- yyyy-MM-dd'T'HH:mm:ssXXX (in Java SimpleDateFormat )
     * eg: 2019-04-30T16:20:46-04:00
     * Intended use is for date-time fields stored in the database and the passed to the client.
     * Dates are mostly stored in the local time of the database server.
     * Certain dates -- like doc_note_info.ctime are stored as UTC time.  Though when passed through to Doc Viewer,
     * underlying JDBC libraries convert them to local time of the server first, if a time zone annotation is provided (on the 'db objects' -- see FddFieldProcessor).
     * For these cases, we need to convert the server time to the browser time.
     * ( We probably should stop doing this in the central libraries and just return the UTC time as seen in the database ).
     * However, most dates are not persisted in UTC time. They are written in local time and not stored with a timezone (the db fields don't support them).
     * While not stored with a timezone, the server with returns these times with timezone of the Java server.  This is problematic and incorrect.
     * ( Java date adds a timezone to the Date object; when retrieved via JDBC, so does java.sql.Types.TIMESTAMP ).
     * So always convert to UTC from the local time provided (even if the time is UTC) and then convert back to local, even if it's not necessary.
     * The toUtc and toLocal functions should always work because times passed from the Java API contain timestamps -- even if these timestamps are not correct.
     * Date-times may not always come from the database -- eg: that cleaned from the version file.
     * More collaborative work is needed across Engineering to determine how to handle the display of times across different time zones.
     *
     * */

    convertDBTimeToLocalTime: function (dtString) {

        if (dtString === null)
            return '';

        var utcTime = moment.utc(dtString),
            localTime = utcTime.local();

        return localTime.format(fvChannel.request('settings').DT_TIME_FMT_STR);

    },

    /**
     * Still using moment to 'format' the date-time string.
     * This is an intermediate refactor.
     * Initially just used for times, but now can have dates too -- depends how you send moment_format_str --
     * this will just take the output generated by the format of the current date/time with moment_format_str
     * and append the timezone abbr to the end.
     *
     */
    getCurrentTimestampWithTimezoneAbbreviation: function( moment_format_str ) {

        moment_format_str = moment_format_str || fvChannel.request('settings').DT_TIME_FMT_AMPM_SPACE_BF_CAPS_STR ;

        var dtNow = new Date();

        var mNow = moment(dtNow);
        var timeStamp = mNow.format( moment_format_str); // ( this is the format used by FDD ) -- ('HH:mm:ss')

        timeStamp = timeStamp + ' ' + this.getTimeZoneAbbrevation(dtNow);

        // For UTC: use moment.utc( dtNow )
        // or --> dtNow.getTime( 1641596655951 ) --> this would be saving it ; then would read back in
        //  dtNow.getTimezoneOffset() -- raw doesn't return without daylight savings -300 ( correct )
        //  mNow.utcOffset() -- also give -300 ( but is this correct with daylight savings ? )
        // mNow.format('Z') -- this works -- provides '-05:00'
        // if we aren't using ... maybe just store on output -- but we have the string ... not sure if that is enough -- would probably want at least the date stored

        return timeStamp;


    },

    /**
     * Use to just append to other moment formats
     * TODO: update to Luxon -- this is a hack, especially for IE
     */
    getTimeZoneAbbrevation: function( dateNow ) {

        dateNow = dateNow || new Date();

        var browserSupportsTimeZones = Intl.DateTimeFormat().resolvedOptions().timeZone;

        var timeZoneAbbr;

        if (browserSupportsTimeZones) {

            /** Use this before library -- change when update to IE */

                // https://stackoverflow.com/questions/67827985/is-there-a-way-to-get-time-zone-abbreviations-in-browser-javascript
            timeZoneAbbr = Intl.DateTimeFormat('en-us', {timeZoneName: 'short'}).formatToParts( dateNow ).find(function (p) {
                return p.type === 'timeZoneName';
            }).value;

            // vs full timezone name: Intl.DateTimeFormat().resolvedOptions().timeZone

        } else {

            // Not perfect, but do an attempt for IE
            // https://stackoverflow.com/questions/1954397/detect-timezone-abbreviation-using-javascript/18346354
            timeZoneAbbr = dateNow.toTimeString().match(new RegExp("[A-Z](?!.*[\(])", "g")).join('');
        }

        return timeZoneAbbr;

    }

});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/FV/extension/moment.js
 ** module id = 71
 ** module chunks = 0
 **/